












import { computed, defineComponent, ref } from '@vue/composition-api'
import useCollectionMap from '@/composables/collection/use-collection-map'

type CollectionMapType = ReturnType<typeof useCollectionMap>

export default defineComponent({
  props: {
    query: {
      type: Object,
      default: {},
    },
  },
  setup () {
    // 未來可根據不同city做更換

    const city = ref<keyof CollectionMapType>('Taiwan')

    const collectionMap = useCollectionMap()

    const collections = computed(() => {
      const _collections = Object.values(collectionMap[city.value] ?? []).filter(collection => collection.locations.length)
      _collections.sort((a, b) => a.sort - b.sort)
      return _collections
    })

    const componentName = computed(() => `CollectionIndex${city.value}`)

    return {
      collections,
      componentName,
    }
  },
})
